import React, { useState } from "react";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import "antd/dist/reset.css";
import { useSelector } from "react-redux";
import userRoleAuth from "../../utils/userRoleAuth/userRoleAuth";
import userRoles from "../../config/userRoles";
import { useNavigate } from "react-router-dom";
import { useViewEmployeePayrollProcessSummary } from "../../queries/payrollQuries";
import { getCurrentMonthNames } from "../../utils/FormatDate/formaDateInMonths";

const EmployeeBankStatement = () => {
  const user = useSelector((state) => state.user.auth);
  const isHr = userRoleAuth(user, userRoles.HR);
  const navigate = useNavigate();
const ALL_MONTHS = [
  "Jan", "Feb", "Mar", "Apr", "May", "Jun",
  "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
];
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth() + 1;

  const [selectedYear, setSelectedYear] = useState(currentYear);
  const [selectedMonth, setSelectedMonth] = useState(currentMonth);

  const { data, isLoading } = useViewEmployeePayrollProcessSummary({
    month: selectedMonth,
    year: selectedYear
  });

  const summary = data?.data?.[0] || {};
  const months = getCurrentMonthNames();

  const handleYearChange = (date) => {
    if (date) {
      const selected = date.year();
      setSelectedYear(selected);
      if (selected === currentYear && selectedMonth > currentMonth) {
        setSelectedMonth(currentMonth);
      }
    }
  };

  const disableFutureYears = (current) => current && current.year() > currentYear;

   const filteredMonths =
  selectedYear < currentYear
    ? ALL_MONTHS
    : ALL_MONTHS.slice(0, currentMonth);
  const isFiltered = selectedYear !== currentYear || selectedMonth !== currentMonth;

  const handleClearFilters = () => {
    setSelectedYear(currentYear);
    setSelectedMonth(currentMonth);
  };

  return (
    <div className="w-full max-w-[1084px] mx-auto px-4">
      <div className="pb-4 mt-8 flex flex-col">
        <h2 className="text-xl font-semibold text-gray-800">Bank Details Summary</h2>
        <p className="text-sm text-gray-500 mb-4">View processed bank statements and payroll process summary</p>

        <div className="bg-white shadow-md border border-gray-100 rounded-lg p-6">
          <div className="flex flex-col sm:flex-row gap-4 items-center">
            <div className="flex flex-col">
              <label className="text-sm font-medium text-gray-700 mb-1">Select Year:</label>
              <DatePicker
                onChange={handleYearChange}
                picker="year"
                value={dayjs(`${selectedYear}`, "YYYY")}
                allowClear={false}
                disabledDate={disableFutureYears}
                className="!border !border-gray-300 !rounded-md !px-3 !py-2 min-w-[120px] text-sm"
              />
            </div>

            <div className="flex flex-col">
              <label className="text-sm font-medium text-gray-700 mb-1">Select Month:</label>
              <select
                value={selectedMonth}
                onChange={(e) => setSelectedMonth(Number(e.target.value))}
                className="border border-gray-300 px-3 py-2 rounded-md text-sm min-w-[120px]"
              >
                {filteredMonths.map((month, index) => (
                  <option key={index} value={index + 1}>{month}</option>
                ))}
              </select>
            </div>
          </div>

          <p className="text-sm text-gray-600 mt-4 flex items-center gap-2">
            Showing summary for: <strong>{months[selectedMonth - 1]} {selectedYear}</strong>
            {isFiltered && (
              <span className="text-blue-800 font-medium cursor-pointer" onClick={handleClearFilters}>
                Clear Filters
              </span>
            )}
          </p>

          <div className="mt-6 flex justify-end">
            <button
              onClick={() => navigate(`/payroll/employee-payroll/view-employee-bank-statement?month=${selectedMonth}&year=${selectedYear}`)}
              className="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 transition-colors"
            >
              Proceed
            </button>
          </div>
        </div>

      
      </div>
    </div>
  );
};

export default EmployeeBankStatement;
